import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IconSize, IconsName } from "@/utils/icons";
import { MotionKeyframes } from "@motionone/dom";
import { AnimationOptions } from "@motionone/types";
import { Motion } from "motion/vue";
import { computed, reactive } from "vue";
import Icon from "../atoms/Icon.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    size: null,
    active: { type: Boolean },
    highlight: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  name: keyof typeof IconsName;
  size?: IconSize;
  active?: boolean;
  highlight?: boolean;
}


const highlight = reactive({
  animation: computed<MotionKeyframes>(() =>
    props.highlight
      ? {
          rotate: [0, 20, 0, -20, 0],
          scale: [1, 1.2, 1],
        }
      : {}
  ),
  options: computed<AnimationOptions>(() =>
    props.highlight
      ? {
          duration: 1.3,
          easing: "ease-out",
          rotate: { offset: [0, 0.08, 0.16, 0.24, 0.32] },
          scale: { offset: [0, 0.5, 0.9], easing: "ease" },
          repeat: Infinity,
        }
      : {}
  ),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Motion), {
    tag: "button",
    class: _normalizeClass(["border-none bg-none outline-none transition-opacity opacity-60 hover:opacity-100 duration-100 focus-visible:outline-white ease-in flex justify-center items-center", { 'opacity-100': __props.active }]),
    animate: _unref(highlight).animation,
    transition: _unref(highlight).options
  }, {
    default: _withCtx(() => [
      _createVNode(Icon, {
        name: __props.name,
        size: __props.size,
        class: "text-red-800"
      }, null, 8, ["name", "size"])
    ]),
    _: 1
  }, 8, ["class", "animate", "transition"]))
}
}

})